import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01f043a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "survey-page" }
const _hoisted_2 = { class: "survey-container" }
const _hoisted_3 = {
  key: 0,
  class: "survey-loading"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "survey-card"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "survey-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/logo1.png",
    alt: "Logo",
    class: "logo"
  })
], -1))
const _hoisted_8 = { class: "survey-body" }
const _hoisted_9 = { class: "question-box" }
const _hoisted_10 = { class: "survey-question" }
const _hoisted_11 = { class: "survey-answers" }
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "radio-circle" }, null, -1))
const _hoisted_14 = { class: "radio-text" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 2,
  class: "survey-card"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "survey-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/logo1.png",
    alt: "Logo",
    class: "logo"
  })
], -1))
const _hoisted_18 = { class: "survey-body" }
const _hoisted_19 = { class: "response-message" }
const _hoisted_20 = {
  key: 3,
  class: "survey-card"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "survey-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/logo1.png",
    alt: "Logo",
    class: "logo"
  })
], -1))
const _hoisted_22 = { class: "survey-body" }
const _hoisted_23 = { class: "error-message" }

import { ref, onMounted, getCurrentInstance } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyView',
  setup(__props) {

const route = useRoute();
const { proxy }: any = getCurrentInstance();

const loading = ref(true);
const showQuestion = ref(false);
const showResponse = ref(false);
const showError = ref(false);

const questionText = ref("");
const answers = ref<any[]>([]);
const selectedAnsId = ref<number | null>(null);
const submitting = ref(false);
const responseMessage = ref("");
const errorMessage = ref("");

const ledKey = (route.query.ledKey as string) || "";
const queId = (route.query.question as string) || "";
const language = (route.query.language as string) || "English";
const answerFromUrl = (route.query.answer as string) || "";

function displayError(msg: string) {
  errorMessage.value = msg;
  loading.value = false;
  showQuestion.value = false;
  showResponse.value = false;
  showError.value = true;
}

function displayResponse(msg: string) {
  responseMessage.value = msg;
  loading.value = false;
  showQuestion.value = false;
  showError.value = false;
  showResponse.value = true;
}

function submitAnswer(ansId: number | string) {
  loading.value = true;
  showQuestion.value = false;

  proxy.$http
    .surveyAnswer({
      ledKey,
      queId,
      ansId,
      language,
    })
    .then((res: any) => {
      const data = res.code === 200 ? res.data : res;
      let text = "";
      if (Array.isArray(data) && data.length > 0) {
        text = data[0].response || data[0].Response || data[0].message || "";
      } else if (typeof data === "string") {
        text = data;
      }
      displayResponse(text || "Thank you for your response.");
    })
    .catch(() => {
      displayError("Failed to submit your answer. Please try again.");
    });
}

function loadQuestion() {
  proxy.$http
    .surveyQuestion({ ledKey, language, queId })
    .then((res: any) => {
      const data = res.code === 200 ? res.data : res;
      if (!data || !Array.isArray(data) || data.length === 0) {
        displayError("No question found.");
        return;
      }

      const totalques = data[0].totalques || "";
      const qText = data[0].question || "";
      questionText.value = (totalques ? totalques + ". " : "") + qText;

      answers.value = data
        .filter((row: any) => row.ansAnswer !== undefined)
        .sort((a: any, b: any) => (a.ansOrd || 0) - (b.ansOrd || 0));

      loading.value = false;
      showQuestion.value = true;
    })
    .catch(() => {
      displayError("Failed to load the question. Please try again.");
    });
}

function handleSubmit() {
  if (selectedAnsId.value === null) return;
  submitting.value = true;
  submitAnswer(selectedAnsId.value);
}

onMounted(() => {
  if (!ledKey || !queId) {
    displayError("Invalid survey link. Missing required parameters.");
    return;
  }

  if (answerFromUrl) {
    submitAnswer(answerFromUrl);
  } else {
    loadQuestion();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (showQuestion.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(questionText.value), 1),
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answers.value, (ans) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: ans.ansId,
                        class: "radio-label"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          name: "surveyAnswer",
                          value: ans.ansId,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedAnsId).value = $event)),
                          class: "radio-input"
                        }, null, 8, _hoisted_12), [
                          [_vModelRadio, selectedAnsId.value]
                        ]),
                        _hoisted_13,
                        _createElementVNode("span", _hoisted_14, _toDisplayString(ans.ansAnswer), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("button", {
                  class: _normalizeClass(["submit-btn", { active: selectedAnsId.value !== null }]),
                  disabled: selectedAnsId.value === null || submitting.value,
                  onClick: handleSubmit
                }, " Submit ", 10, _hoisted_15)
              ])
            ]))
          : (showResponse.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("p", _hoisted_19, _toDisplayString(responseMessage.value), 1)
                ])
              ]))
            : (showError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("p", _hoisted_23, _toDisplayString(errorMessage.value), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
    ])
  ]))
}
}

})